import { SubscriptionActions } from "@dots-crm/contracts/client";

export const SUBSCRIPTION_ENDPOINTS_URLS = {
  create: "subscription",
  renew: "subscription/renew",
  readMany: "subscription",
  readUserSubscription: "subscription/my-subscription",
  updateStatus: ({ subscriptionId }: SubscriptionActions["updateStatus"]["params"]) =>
    `subscription/${subscriptionId}/status`,
  delete: ({ subscriptionId }: SubscriptionActions["delete"]["params"]) =>
    `subscription/${subscriptionId}`,
};

export const SUBSCRIPTION_TAGS = {
  subscription: "subscription",
};
